import { Menu, MenuItem } from '@mui/material';
import { useMemo } from 'react';
import { domainEventBus, WindowLevelSetEvent } from '~/domain/events';
import { Image3D } from '~/domain/patient/image3d';
import {
    WindowLevel,
    WindowingPreset,
    buildPresetOptions,
    findMatchingPreset,
} from '~/domain/patient/windowLevel';

interface WindowingPresetMenuProps {
    /** Anchor element the menu drops from (e.g. the preset chevron button). */
    anchorEl: HTMLElement | null;
    onClose: () => void;
    image: Image3D;
    windowLevel: WindowLevel;
}

const WindowingPresetMenu = ({
    anchorEl,
    onClose,
    image,
    windowLevel,
}: WindowingPresetMenuProps) => {
    const presetOptions = useMemo(() => buildPresetOptions(image), [image]);
    const currentPreset = findMatchingPreset(presetOptions, windowLevel);

    const handleSelect = (preset: WindowingPreset) => {
        if (preset.disabled) {
            return;
        }
        domainEventBus.publishSync(
            new WindowLevelSetEvent(
                new WindowLevel(preset.ww, preset.wc),
                image.seriesUid,
                'user'
            )
        );
        onClose();
    };

    return (
        <Menu
            open={!!anchorEl}
            onClose={onClose}
            anchorEl={anchorEl}
            slotProps={{
                paper: { sx: { bgcolor: 'rgba(0, 0, 0, 0.85)' } },
            }}
        >
            {presetOptions.map((preset) => (
                <MenuItem
                    key={preset.name}
                    onClick={() => handleSelect(preset)}
                    disabled={preset.disabled}
                    selected={
                        !preset.disabled && currentPreset?.name === preset.name
                    }
                    sx={{ fontSize: 11 }}
                >
                    {preset.disabled
                        ? `${preset.name} (N/A)`
                        : `${preset.name} (${Math.round(preset.ww)}, ${Math.round(preset.wc)})`}
                </MenuItem>
            ))}
        </Menu>
    );
};

export default WindowingPresetMenu;
